// 世界模拟器状态管理
import { create } from 'zustand'
import { v4 as uuidv4 } from 'uuid'

export const useWorldSimulatorStore = create((set, get) => ({
  // 世界列表
  worlds: [],
  
  // 当前选中的世界
  currentWorld: null,
  
  // 当前会话
  currentSession: null,
  
  // 当前段落
  currentParagraph: '',
  
  // 当前背景图片
  currentBackgroundImage: '',
  
  // 当前选项
  currentOptions: [],
  
  // 量化数值
  quantitativeValues: {},
  
  // 对话历史
  conversationHistory: [],
  
  // 筛选状态
  filters: {
    tags: [],
    type: null,
    style: null,
    sortBy: 'popular' // 'popular', 'new', 'rating', 'favorites'
  },
  
  // 加载世界列表
  loadWorlds: async () => {
    try {
      const worldSimulatorStorageService = (await import('../services/worldSimulatorStorageService')).default
      const worlds = await worldSimulatorStorageService.getAllWorlds()
      set({ worlds })
      return worlds
    } catch (error) {
      console.error('加载世界列表失败:', error)
      return []
    }
  },
  
  // 选择世界
  selectWorld: (world) => {
    set({ currentWorld: world })
  },
  
  // 开始会话
  startSession: async (worldId, userId = 'guest') => {
    try {
      const worldSimulatorStorageService = (await import('../services/worldSimulatorStorageService')).default
      const session = await worldSimulatorStorageService.createSession(worldId, userId)
      set({ currentSession: session })
      return session
    } catch (error) {
      console.error('创建会话失败:', error)
      throw error
    }
  },
  
  // 更新当前段落
  setCurrentParagraph: (paragraph) => {
    set({ currentParagraph: paragraph })
  },
  
  // 更新背景图片
  setCurrentBackgroundImage: (imageUrl) => {
    set({ currentBackgroundImage: imageUrl })
  },
  
  // 设置选项
  setOptions: (options) => {
    set({ currentOptions: options })
  },
  
  // 清除选项
  clearOptions: () => {
    set({ currentOptions: [] })
  },
  
  // 更新量化数值
  updateQuantitativeValue: (systemName, value) => {
    set((state) => ({
      quantitativeValues: {
        ...state.quantitativeValues,
        [systemName]: value
      }
    }))
  },
  
  // 添加对话消息
  addMessage: (message) => {
    const newMessage = {
      id: uuidv4(),
      ...message,
      timestamp: message.timestamp || Date.now()
    }
    set((state) => ({
      conversationHistory: [...state.conversationHistory, newMessage]
    }))
    return newMessage
  },
  
  // 设置筛选
  setFilters: (filters) => {
    set({ filters })
  },
  
  // 重置当前会话
  resetCurrentSession: () => {
    set({
      currentWorld: null,
      currentSession: null,
      currentParagraph: '',
      currentBackgroundImage: '',
      currentOptions: [],
      quantitativeValues: {},
      conversationHistory: []
    })
  }
}))

